<!--  -->
<template>
    <div class="openmini">
       
        <div>
             <wx-open-launch-weapp
            id="launch-btn"
            username="gh_67fc2a203508"
            path="pages/index"
            >
            <script type="text/wxtag-template">
                <style>.btn { padding: 12px;background:green }</style>
                <button class="btn">打开小程序</button>
            </script>
            </wx-open-launch-weapp>
        </div>
    </div>
   
</template>
<script>

import * as config from "@/api/api";

export default {
    data() {
        return {}
    },
    created() {},
    mounted() {
       
        //   localStorage.setItem("appid_vote", res.data.data.appId);
          // console.log( res.data.data)
          this.$wx.config({
            debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId:"wx7550763d1ec5383d",
            timestamp: 0,
            nonceStr: '123456',
            signature: 'sadasd',
            jsApiList: ['chooseImage'],
            openTagList: ['wx-open-launch-weapp']
          });
       
         
          
            this.$wx.ready((res) => {
                // alert(1)
                // alert(res)
            
            
            })
             this.$wx.error();((err) => {
                //  alert(2)
                alert(JSON.stringify(err))
            
            
            })
            
        
      
    },
    methods: {
        handleLaunchFn(e) {
            console.log('success', e);
            alert("成功")
        },
        handleErrorFn(e) {
            console.log('fail', e.detail);
            alert("失败")
        },
    },
}
</script>
<style scoped lang='scss'>
    .openmini{
        width: 100%;
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        >div{
            width: 300px;
            height: 300px;
            display: flex;
            align-items: center;
            justify-content: center;
            // background-color: #000;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/zhongzhuan.vue